import { AppModule } from 'app/module';
import {
    API_ENDPOINT_RECRUITER_INQUIRY,
    API_ENDPOINT_RECRUITER_INQUIRY_GDPR_APPROVE,
} from 'app/endpoints';
import { Input } from 'module/input/main';
import { Textarea } from 'module/textarea/main';
import { postJson } from 'util/xhr';
import { serializeJson } from 'util/form';
import { Captcha } from 'module/captcha/main';
import { ValidationBoxBase } from 'module/validationBox/main';
import { Checkbox } from 'module/checkbox/main';
import { GdprModal } from 'module/gdprModal/main';
import { generic } from 'util/validationMessages';
import Template from './template.hbs';
import './styles.scss';

export class CompanyRecruiterInquiryModal extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            inner: '.m-companyRecruiterInquiryModal__inner',
            form: '.m-companyRecruiterInquiryModal__form',
            validationBox: '.m-validationBoxBase',
            firstName: '.m-companyRecruiterInquiryModal__firstName .m-input',
            surName: '.m-companyRecruiterInquiryModal__surName .m-input',
            email: '.m-companyRecruiterInquiryModal__email .m-input',
            checkbox: '.m-companyRecruiterInquiryModal__checkbox .m-checkbox',
            message: '.m-companyRecruiterInquiryModal__textarea .m-textarea',
            submitButton: '.m-companyRecruiterInquiryModal__submit',
            icon: '.m-companyRecruiterInquiryModal__closeSvg',
            captcha: '.m-companyRecruiterInquiryModal__captcha .m-captcha',
            headline: '.m-companyRecruiterInquiryModal__headline',
            avatar: '.m-companyRecruiterInquiryModal__avatar',
            avatarContainer: '.m-companyRecruiterInquiryModal__avatarContainer',
            overlay: '.m-companyRecruiterInquiryModal__overlay',
            gdprModal: '.m-companyRecruiterInquiryModal__gdpr .m-gdprModal',
        };
    }

    domEvents() {
        if (this.dom.submitButton) {
            this.dom.form.addEventListener('submit', (e) => this.validateFormAndUser(e));
            this.dom.submitButton.addEventListener('click', (e) => this.validateFormAndUser(e));
        }
        if (this.dom.icon) {
            this.dom.icon.addEventListener('click', () => this.close());
        }
        if (this.dom.overlay) {
            this.dom.overlay.addEventListener('click', () => this.close());
        }
    }

    subEvents() {
        if (this.captcha) {
            this.captcha.events.on('ready', () => this.captchaReady());
        }
        if (this.gdprModal) {
            this.gdprModal.events.on('acceptGdpr', () => this.acceptGdpr());
            this.gdprModal.events.on('removeModalStyle', () => this.closeGdprModal());
        }
    }

    getPropsFromDom() {
        return {
            companyName: this.dom.el ? this.dom.el.getAttribute('data-company-name') : '',
        };
    }

    subs() {
        if (this.dom.validationBox) {
            this.validationBox = new ValidationBoxBase(this.dom.validationBox);
        }
        if (this.dom.gdprModal) {
            this.gdprModal = new GdprModal(this.dom.gdprModal);
        }

        if (this.dom.email) {
            this.email = new Input(this.dom.email);
        }

        if (this.dom.firstName) {
            this.firstName = new Input(this.dom.firstName);
        }

        if (this.dom.surName) {
            this.surName = new Input(this.dom.surName);
        }

        if (this.dom.message) {
            this.message = new Textarea(this.dom.message);
        }

        if (this.dom.checkbox) {
            this.checkbox = new Checkbox(this.dom.checkbox);
        }

        if (this.dom.captcha && this.dom.submitButton && this.props.visible) {
            // Lazy load (props.visible) for better performance.
            this.captcha = new Captcha(this.dom.captcha);
        }
    }

    subsProps() {
        if (this.props.userEmail && this.email) {
            this.email.updateProps({ value: this.props.userEmail, readOnly: true, disabled: true }, true);
        }

        if (this.props.userFirstName && this.firstName) {
            this.firstName.updateProps({ value: this.props.userFirstName }, true);
        }

        if (this.props.userSurName && this.surName) {
            this.surName.updateProps({ value: this.props.userSurName }, true);
        }
    }

    validateFormAndUser(e) {
        e.preventDefault();

        if (this.validation.validate()) {
            this.captcha.execute();
        }
    }

    validationRules() {
        this.validation.useMessages(generic);
        this.validation.addRule(this.email, ['email']);
        this.validation.addRule(this.firstName, ['required']);
        this.validation.addRule(this.surName, ['required']);
        this.validation.addRule(this.message, ['required']);
        this.validation.addRule(this, {
            name: 'failed_to_send_mail',
            message: 'Die E-Mail konnte nicht gesendet werden, bitte kontaktiere newsservice@karriere.at.',
            validationMessageOutlet: this.validationBox,
        });
        this.validation.addRule(this, {
            name: 'failed_to_send_copy',
            message: 'Die Email an den Ansprechpartner wurde versandt, leider konnte die Kopie an dich '
                + 'nicht erfolgreich gesendet werden. Bei Fragen kontaktiere bitte newsservice@karriere.at.',
            validationMessageOutlet: this.validationBox,
        });
    }

    afterRender() {
        if (this.captcha && this.captcha.loaded()) {
            this.captchaReady();
        }
    }

    captchaReady() {
        this.captcha.activate(() => this.submit());
        this.updateProps({ enabled: true }, true);
    }

    submit() {
        if (this.request) {
            this.request.abort();
        }

        this.request = postJson(
            API_ENDPOINT_RECRUITER_INQUIRY,
            {
                data: serializeJson(this.dom.form),
            },
            (response) => this.onResponse(response),
            (error) => this.onResponseError(error),
        );
    }

    onResponse(response) {
        if (response.gdpr) {
            this.dom.inner.classList.add('m-companyRecruiterInquiryModal__inner--hide');
            this.gdprModal.setProps(response.gdpr);
            this.gdprModal.updateProps({ visible: true, active: true, scrollTop: 0 }, true);
            this.gdprModal.checkIfScrollEnd();
        } else {
            if (this.captcha) {
                this.captcha.reset();
            }
            this.updateProps({ visible: false, enabled: false }, true);
            this.events.emit('removeModalStyle');
            this.events.emit('showCompanyRecruiterInquiryToast');
        }
    }

    onResponseError(response) {
        this.dom.submitButton.disabled = false;
        if (!response || !response.errors) return;

        this.validation.handleBackendValidationErrors(response);
        this.captcha.reset();
    }

    close() {
        if (this.captcha && this.captcha.loaded()) {
            this.captcha.reset();
        }
        this.updateProps({ visible: false, enabled: false, errors: false }, true);
        this.events.emit('removeModalStyle');
    }

    acceptGdpr() {
        const gdprCheckBoxSize = Object.keys(this.gdprModal.props.optionalBox.items).length;
        const data = serializeJson(this.dom.form);
        delete data.firstname;
        delete data.recruiterEmail;
        delete data.surname;
        delete data.message;

        for (let i = 0; i < gdprCheckBoxSize; i += 1) {
            data[this.gdprModal.props.optionalBox.items[i].name] = this.gdprModal.props.optionalBox.items[i].checked;
        }

        this.gdprModal.updateProps({ visible: false }, true);
        this.dom.inner.classList.remove('m-companyRecruiterInquiryModal__inner--hide');

        if (this.request) {
            this.request.abort();
        }

        this.dom.submitButton.disabled = true;

        this.request = postJson(
            API_ENDPOINT_RECRUITER_INQUIRY_GDPR_APPROVE,
            {
                data,
            },
            () => this.onGdprResponse(),
            () => this.onGdprResponseError(),
        );
    }

    onGdprResponse() {
        this.submit();
    }

    onGdprResponseError() {
        if (this.captcha && this.captcha.loaded()) {
            this.captcha.reset();
        }
        this.dom.submitButton.disabled = false;
    }

    closeGdprModal() {
        this.dom.inner.classList.remove('m-companyRecruiterInquiryModal__inner--hide');
        this.dom.submitButton.disabled = false;
        if (this.captcha && this.captcha.loaded()) {
            this.captcha.reset();
        }
    }

    loadCaptcha() {
        if (this.captcha) {
            this.captcha.load();
        }
    }
}
